import React, { Component } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import debounce from '../utils/debounce';

const Button = styled.button`
  display: {props.hidden ? 'none' : 'block'};
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  border-color: #ffffff !important;
  border-style: solid !important;
  border-width: 1px !important;
  outline: none;
  cursor: pointer;
  color: #FFFFFF !important;
  background-color: #fa5a56 !important;
  border-radius: 25px;
  height: 40px;
  width: 40px;
`;

class ToTopButton extends Component {
  state = {
    scrollOffset: 0,
  }

  componentDidMount() {
    window.onscroll = debounce(() => {
      this.setState({ scrollOffset: window.pageYOffset });
    }, 100);
  }

  takeMeToTheTop = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
  }

  render() {
    const { scrollOffset } = this.state;

    return (
      <Button
        type="button"
        className="btn"
        onClick={this.takeMeToTheTop}
        hidden={scrollOffset === 0}
      >
        <FontAwesomeIcon icon="arrow-up" />
      </Button>
    );
  }
}

export default ToTopButton;
